import { useEffect, useState } from 'react';
import SFCCookingHappyChef from '../../../assets/images/sticky-fingers-cooking_happy-chef_200x.png';
import { Joke } from '../../../types/content.type';
import { LessonPlan, Recipe } from '../../../types/lessonPlan.type';
import SafeHTMLDisplay from '../../common/SafeHTMLDisplay';
import './RecipeJokes.css';

interface RecipeJokesProps {
  recipe?: Recipe;
  lessonPlan?: LessonPlan | null;
}

const normalizeJokeText = (text: string): string =>
  text
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();

const stripDuplicateJokeSetup = (name: string, content: string): string => {
  if (!content?.trim()) return content;

  const normalizedName = normalizeJokeText(name);
  if (!normalizedName) return content;

  if (/<[a-z][\s\S]*>/i.test(content)) {
    const doc = new DOMParser().parseFromString(content, 'text/html');
    const paragraphs = Array.from(doc.body.querySelectorAll('p'));

    if (paragraphs.length > 1 && normalizeJokeText(paragraphs[0].innerHTML) === normalizedName) {
      paragraphs[0].remove();
      return doc.body.innerHTML.trim();
    }

    return content;
  }

  const lines = content.split('\n');
  if (lines.length > 1 && normalizeJokeText(lines[0]) === normalizedName) {
    return lines.slice(1).join('\n').trim();
  }

  return content;
};

const RecipeJokes: React.FC<RecipeJokesProps> = ({ recipe, lessonPlan }) => {
  const [jokes, setJokes] = useState<Joke[]>([]);
  useEffect(() => {
    if (lessonPlan) {
      const lessonPlanJokes: Joke[] = [];
      lessonPlan?.recipes.forEach((recipe) => {
        if (recipe.jokes?.length) {
          lessonPlanJokes.push(...recipe.jokes);
        }
      });
      if (lessonPlanJokes.length) {
        setJokes(lessonPlanJokes);
      }
    } else if (recipe) {
      if (recipe.jokes?.length) {
        setJokes(recipe.jokes);
      }
    }
  }, [recipe, lessonPlan]);
  return (
    <>
      {jokes.map((joke, index) => (
        <div
          className="recipe-child-joke"
          key={`joke-${index}`}
        >
          <div className="joke-main">
            <img
              src={SFCCookingHappyChef}
              loading="lazy"
              width="70"
              alt=""
              className="image-joke"
            />
            <h3 className="text-info fw-bold">{joke.name}</h3>
            <div className="divider-35"></div>
            <div className="joke">
              <SafeHTMLDisplay htmlContent={stripDuplicateJokeSetup(joke.name, joke.content)} />
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default RecipeJokes;
